import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Maillist } from '../interfaces/maillist';
import { Observable, Subject } from 'rxjs';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class EmailListService {
  maillistDataSubject = new Subject();
  maillistDatanewSubject = new Subject();
  company: any;

  constructor(
    private http: HttpClient,
    private storage: Storage
  ) { }

  // TODO: wird noch bearbeitet (NICHT FERTIG)

  async ionViewWillEnter() {
    if (!this.company._id)
      this.company = await this.storage.get(environment.storage.company);
  }

  // TODO: ohne Promise +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // TODO: ohne Promise +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  getAllEmailling(companyId: string): Observable<any> {
    return this.http.get<Maillist[]>(`${environment.url}/bucket/${environment.buckets.mailing_list}/data?filter={"company": "${companyId}"}`)
  }


  saveEmailling(emailing) {
    if (emailing._id) {
      const flated = this.flatEmailing(emailing);
      return this.updateEmailling(flated);
    } else {
      console.log('COMPANY_KEY: ', emailing.company);
      return this.addEmailling(emailing);
    }
  }


  private addEmailling(mailing: any): Observable<any> {
    return this.http.post<any[]>(`${environment.url}/bucket/${environment.buckets.mailing_list}/data/`, mailing)
  }


  private updateEmailling(mailing: any): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/bucket/${environment.buckets.mailing_list}/data/${mailing._id}`,
      mailing
    );

  }

  deleteEmaillingh(mailGroup) {

  }

  flatEmailing(emailing: Maillist) {
    throw new Error('Method not implemented.');
  }

  // TODO: wie EventType
  // async ionViewWillEnter() {
  //   if (!this.company._id)
  //     this.company = await this.storage.get(environment.storage.company);
  // }

  // getAllEventtypes(companyId: string): Observable<any> {
  //   return this.http.get(`${ environment.url } / bucket / ${ environment.buckets.eventType } / data ? filter = { "company": "${companyId}" } & relation=true`)
  // }

  // saveEvent(eventType: EventType): Observable<any> {
  //   if (eventType._id) {
  //     const flated = this.flatEventtype(eventType);
  //     return this.updateEventtype(flated);
  //   } else {
  //     console.log('COM_KEY', eventType.company);
  //     return this.addEventtype(eventType);
  //   }
  // }

  // private updateEventtype(eventType: any): Observable<any> {// FUNKTIONIERT
  //   return this.http.put(`${ environment.url } / bucket / ${ environment.buckets.eventType } / data / ${ eventType._id }`, eventType);
  // }

  // private addEventtype(eventType): Observable<any> {// FUNKTIOINIERT
  //   return this.http.post(`${ environment.url } / bucket / ${ environment.buckets.eventType } / data / `, eventType);
  // }

  // deleteEventtype(id: string) { //FUNKTIONIERT
  //   return this.http.delete(`${ environment.url } / bucket / ${ environment.buckets.eventType } / data / ${ id }`);
  // }

  // // TODO: Flaten von Objekt
  // flatEventtype(eventtype) {
  //   if (typeof eventtype.company !== "string")
  //     eventtype.company = eventtype.company._id;//flaten funktioniert
  //   console.log('flatEventtype:', eventtype.company);
  //   return eventtype;
  // }

  // TODO: ohne Promise +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // TODO: ohne Promise +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  getEmailListFromCompany(companyId: string) {
    return new Promise<Maillist[]>((resolve, reject) => {
      this.http
        .get<Maillist[]>(`${environment.url}/bucket/${environment.buckets.mailing_list}/data?filter={"company":"${companyId}"}`).subscribe(res =>
          resolve(res), err => reject(err));
    })
  }
  getEmailListFromCompanySettings(companyId: string): Observable<any[]> {
    // return new Promise<Maillist[]>((resolve, reject) => {
    //   this.http
    //     .get<Maillist[]>(
    //       `${ environment.url } / bucket / ${ environment.buckets.mailing_list } / data ? filter = { "company": "${companyId}" }`
    //     ).subscribe(res => resolve(res), err => reject(err));
    // })
    return this.http.get<Maillist[]>(`${environment.url}/bucket/${environment.buckets.mailing_list}/data?filter={ "company":"${companyId}"}`)
  }

  updateEmailListFromCompany(mailing_list: Maillist) {
    return new Promise<Maillist>((resolve, reject) => {
      this.http
        .put<Maillist>(
          `${environment.url}/bucket/${environment.buckets.mailing_list}/data/${mailing_list._id}`,
          mailing_list
        ).subscribe(res => resolve(res), err => reject(err));

    })

  }

  deleteEmailListFromCompany(mailing_list: Maillist) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<string[]>(
          `${environment.url}/bucket/${environment.buckets.mailing_list}/data/${mailing_list._id}`
        ).subscribe(res => resolve(res), err => reject(err));
    })
  }

  createEmailListFromCompany(mailing_list: Maillist) {
    return new Promise<Maillist>((resolve, reject) => {
      this.http
        .post<Maillist>(
          `${environment.url}/bucket/${environment.buckets.mailing_list}/data`, mailing_list
        ).subscribe(res => resolve(res), err => reject(err));

    })

  }
}
